/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../../hook/use-api-handler";
import { ORGANIZATION_CATEGORY } from "./organization-table-constant";

const useOrganizationTable = () => {
    const { fetchData, error, loading } = useAPIHandler();
    const [organizations, setOrganizations] = useState([]);
        const [rowsPerPage, setRowsPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("")

    const fetchOrganizations = async () => {
        // const URL = `/organization?page=${page}&pageSize=${pageSize}`;
        const URL = `/organization?pageSize=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`;
        const METHOD = "GET";

        try {
            const result = await fetchData({
                url: URL,
                method: METHOD,
            });
         
            setOrganizations(result?.data?.organizations); 
            const totalItems = result?.data?.pagination?.total || 0;
            setTotalPages(Math.ceil(totalItems / rowsPerPage)); 
        } catch (err) {
            console.error("Error fetching organizations:", err);
        }
    };

    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
      };
    
      const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
      };
    
      const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
      };

    function getOrganizationCategoryName(id) {
            const category = ORGANIZATION_CATEGORY.find(item => item.id === id);
            return category ? category.name : 'N/A';
          }

    useEffect(() => {
        fetchOrganizations(); 
    }, [rowsPerPage, currentPage, searchQuery]);

    return {
        organizations,
        loading,
        error,
        getOrganizationCategoryName,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        totalPages,
        currentPage,
        rowsPerPage,
        searchQuery, 
        setSearchQuery
    };
};

export default useOrganizationTable;
